(function () {
  'use strict';

  angular.module('app').component('debitNotePage', debitNoteDetailCtrl());

  function debitNoteDetailCtrl() {
    return {
      bindings: {},
      controller: DebitNoteDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/debit-notes/debit-note-page.component.html',
    };
  }

  DebitNoteDetailCtrl.$inject = ['$location', '$routeParams', 'AbilityService', 'DebitNoteService'];

  function DebitNoteDetailCtrl($location, $routeParams, AbilityService, DebitNoteService) {
    const vm = this;
    const itemId = $routeParams.id;

    vm.permissions = {
      canCreate: AbilityService.can('create_debitnote_accountadmin'),
    };
    vm.mode = $routeParams.mode;
    const getItem = () => {
      if (itemId) {
        //edit
        vm.loadingItem = true;
        DebitNoteService.getDebitNote(itemId).then(function (data) {
          vm.debitNote = data;

          vm.loadingItem = false;
        });
      } else {
        vm.debitNote = {};
      }
    };

    // Initializers
    getItem();

    vm.onSavedItem = (item) => {
      $location.path(`/debit_notes/${item.id}`);
    };

    vm.onCanceledItem = () => {
      $location.path('/debit_notes');
    };
  }
})();
